import React, { ReactNode } from "react";
import "./ScoreBoardItem.scss";

interface IProps {
    title: string
    titleOrientation?: 'left' | 'right'
    largeNumbers?: boolean
    children: ReactNode

}

export function ScoreBoardItem({
    title,
    titleOrientation = 'left',
    largeNumbers = false,
    children
}: IProps) {
    return (
        <div className={`score-board-item-wrapper title-${titleOrientation} ${largeNumbers ? 'large-numbers' : ''}`}>
            <div className="score-board-title">
                {title}
            </div>
            <div className="score-board-contents">
                {children}
            </div>
        </div>
    )
}
